import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { HeadingContext } from './Section';

const Container = styled.div`
  ${({ gapless, paddingTop }) =>
    !gapless &&
    css`
      padding-top: ${paddingTop.desktop}px;
      @media (${UI.Viewport.to.Desktop}) {
        padding-top: ${paddingTop.tablet}px;
      }
      &:first-child {
        padding-top: 0px;
      }
    `}
  &.background-black {
    background-color: black;
    color: white;
    padding-top: 48px;
    padding-bottom: 48px;

    @media (${() => UI.Viewport.to.Desktop}) {
      padding-top: 24px;
      padding-bottom: 24px;
    }
  }
`;

const Module = styled.div`
  ${({ gutterless }) =>
    !gutterless &&
    css`
      padding: 0 ${Board.Gutter.Desktop}px;
      @media (${UI.Viewport.to.Desktop}) {
        padding: 0 ${Board.Gutter.Tablet}px;
      }
      @media (${UI.Viewport.to.Tablet}) {
        padding: 0 ${Board.Gutter.Mobile}px;
      }
    `}
`;

export default ({
  selectable = true,
  prior,
  selector,
  onClick,
  children,
  gapless = false,
  styles,
  ...props
}) => {
  const { moduleType } = Board.build;
  const containerPadding = {
    Article: { desktop: Board.Gap.Desktop / 2, tablet: Board.Gap.Tablet / 2 },
  };
  const paddingTop = containerPadding[moduleType] || {
    desktop: Board.Gap.Desktop,
    tablet: Board.Gap.Tablet,
  };

  let backgroundClass = null
  if (_.get(Board.Value.contents, selector?.split('/'))?.type === 'CardSet') {
    if (_.get(Board.Value, Board.Path.concat('settings', 'backgroundColor')) === 'black') {
      backgroundClass = 'background-black'
    }
  }

  return (
    <HeadingContext.Consumer>
      {({ headingLevel } = {}) => (
        <Container
          className={backgroundClass}
          gapless={(!!headingLevel && !prior) || gapless}
          paddingTop={paddingTop}
          css={styles}
        >
          <UI.Selection
            selectable={selectable}
            unwrapped={!selectable}
            onClick={onClick}
            selector={selector}
          >
            <Module {...props}>{children}</Module>
          </UI.Selection>
        </Container>
      )}
    </HeadingContext.Consumer>
  );
};
